import { useContext } from 'react'
import { VersionContextValue, VersionContext } from '../containers/Version'

export function useVersion(): VersionContextValue {
  return useContext(VersionContext)
}
